'use client';

import { useEffect, useState } from 'react';
import { ChevronUp } from 'lucide-react';

/**
 * 페이지 최상단으로 스크롤하는 버튼 컴포넌트
 * 스크롤이 일정 높이 이상 내려갔을 때 표시됨
 */
export function TopButton() {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // 스크롤이 300px 이상 내려가면 버튼 표시
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    // 스크롤 이벤트 리스너 등록
    window.addEventListener('scroll', toggleVisibility);

    // 초기 상태 확인
    toggleVisibility();

    // 클린업
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  /**
   * 페이지 최상단으로 부드럽게 스크롤
   */
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      className={`
        fixed bottom-8 right-8 z-50
        p-3 rounded-full
        bg-blue-600 hover:bg-blue-700
        text-white shadow-lg
        transition-all duration-300 ease-in-out
        ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}
      `}
      aria-label="페이지 최상단으로 이동"
    >
      <ChevronUp className="w-6 h-6" />
    </button>
  );
}
